// extracted by mini-css-extract-plugin
export default {"root":"aJM6jZTv0FGmbmVoeSGw","icon":"BYayNMDdPVgrna3NsHfu","title":"G4SxYH1X0X2e4J1z7GPV"};